"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uiPlaceholder = exports.$uiPlaceholder = exports.uiConnector = exports.$uiConnector = exports.uiDivider = exports.$uiDivider = exports.uiRange = exports.$uiRange = exports.uiS3Uploader = exports.$uiS3Uploader = exports.uiVisual = exports.$uiVisual = exports.uiFocus = exports.$uiFocus = exports.uiShowOnHover = exports.$uiShowOnHover = exports.uiIconSvg = exports.$uiIconSvg = exports.uiIconStack = exports.$uiIconStack = exports.uiLoader = exports.$uiLoader = exports.uiAlert = exports.$uiAlert = exports.uiBadge = exports.$uiBadge = exports.uiInfo = exports.$uiInfo = exports.uiMenuFolder = exports.$uiMenuFolder = exports.uiMenuDropdown = exports.$uiMenuDropdown = exports.uiPanel = exports.$uiPanel = exports.uiOverlay = exports.$uiOverlay = exports.uiBottomToolbar = exports.$uiBottomToolbar = exports.uiView = exports.$uiView = exports.uiModal = exports.$uiModal = exports.uiCard = exports.$uiCard = exports.uiFormRow = exports.$uiFormRow = exports.uiForm = exports.$uiForm = exports.uiTable = exports.$uiTable = exports.uiInputGroupLegacy = exports.$uiInputGroupLegacy = exports.uiInputGroup = exports.$uiInputGroup = exports.uiAutosizeInput = exports.$uiAutosizeInput = exports.uiSelect = exports.$uiSelect = exports.uiInputText = exports.$uiInputText = exports.uiCalendar = exports.$uiCalendar = exports.uiCollapser = exports.$uiCollapser = exports.uiStatusFilter = exports.$uiStatusFilter = exports.uiButtonSwitch = exports.$uiButtonSwitch = exports.uiButton = exports.$uiButton = exports.uiCheckboxLegacy = exports.$uiCheckboxLegacy = exports.uiCheckbox = exports.$uiCheckbox = exports.uiA = exports.$uiA = void 0;

var _get_block = _interopRequireDefault(require("../ui/get_block"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Do not edit directly
// Generated on Wed, 31 Jan 2024 01:00:34 GMT
var $uiA = 'env-a-';
exports.$uiA = $uiA;
var uiA = (0, _get_block.default)('env-a-'); // ACSS

exports.uiA = uiA;
var $uiCheckbox = 'env-checkbox';
exports.$uiCheckbox = $uiCheckbox;
var uiCheckbox = (0, _get_block.default)('env-checkbox'); // Control

exports.uiCheckbox = uiCheckbox;
var $uiCheckboxLegacy = 'env-checkbox-legacy';
exports.$uiCheckboxLegacy = $uiCheckboxLegacy;
var uiCheckboxLegacy = (0, _get_block.default)('env-checkbox-legacy'); // Control

exports.uiCheckboxLegacy = uiCheckboxLegacy;
var $uiButton = 'env-button';
exports.$uiButton = $uiButton;
var uiButton = (0, _get_block.default)('env-button'); // Control

exports.uiButton = uiButton;
var $uiButtonSwitch = 'env-button-switch';
exports.$uiButtonSwitch = $uiButtonSwitch;
var uiButtonSwitch = (0, _get_block.default)('env-button-switch'); // Control

exports.uiButtonSwitch = uiButtonSwitch;
var $uiStatusFilter = 'env-status-filter';
exports.$uiStatusFilter = $uiStatusFilter;
var uiStatusFilter = (0, _get_block.default)('env-status-filter'); // Control

exports.uiStatusFilter = uiStatusFilter;
var $uiCollapser = 'env-collapser';
exports.$uiCollapser = $uiCollapser;
var uiCollapser = (0, _get_block.default)('env-collapser'); // Control

exports.uiCollapser = uiCollapser;
var $uiCalendar = 'env-calendar';
exports.$uiCalendar = $uiCalendar;
var uiCalendar = (0, _get_block.default)('env-calendar'); // Control

exports.uiCalendar = uiCalendar;
var $uiInputText = 'env-input-text';
exports.$uiInputText = $uiInputText;
var uiInputText = (0, _get_block.default)('env-input-text'); // Input

exports.uiInputText = uiInputText;
var $uiSelect = 'env-select';
exports.$uiSelect = $uiSelect;
var uiSelect = (0, _get_block.default)('env-select'); // Input

exports.uiSelect = uiSelect;
var $uiAutosizeInput = 'env-autosize-input';
exports.$uiAutosizeInput = $uiAutosizeInput;
var uiAutosizeInput = (0, _get_block.default)('env-autosize-input'); // Input

exports.uiAutosizeInput = uiAutosizeInput;
var $uiInputGroup = 'env-input-group';
exports.$uiInputGroup = $uiInputGroup;
var uiInputGroup = (0, _get_block.default)('env-input-group'); // Input

exports.uiInputGroup = uiInputGroup;
var $uiInputGroupLegacy = 'env-input-group-legacy';
exports.$uiInputGroupLegacy = $uiInputGroupLegacy;
var uiInputGroupLegacy = (0, _get_block.default)('env-input-group-legacy'); // Input

exports.uiInputGroupLegacy = uiInputGroupLegacy;
var $uiTable = 'env-table';
exports.$uiTable = $uiTable;
var uiTable = (0, _get_block.default)('env-table'); // Table

exports.uiTable = uiTable;
var $uiForm = 'env-form';
exports.$uiForm = $uiForm;
var uiForm = (0, _get_block.default)('env-form'); // Form

exports.uiForm = uiForm;
var $uiFormRow = 'env-form-row';
exports.$uiFormRow = $uiFormRow;
var uiFormRow = (0, _get_block.default)('env-form-row'); // Form

exports.uiFormRow = uiFormRow;
var $uiCard = 'env-card';
exports.$uiCard = $uiCard;
var uiCard = (0, _get_block.default)('env-card'); // Container

exports.uiCard = uiCard;
var $uiModal = 'env-modal';
exports.$uiModal = $uiModal;
var uiModal = (0, _get_block.default)('env-modal'); // Container

exports.uiModal = uiModal;
var $uiView = 'env-view';
exports.$uiView = $uiView;
var uiView = (0, _get_block.default)('env-view'); // Container

exports.uiView = uiView;
var $uiBottomToolbar = 'env-bottom-toolbar';
exports.$uiBottomToolbar = $uiBottomToolbar;
var uiBottomToolbar = (0, _get_block.default)('env-bottom-toolbar'); // Container

exports.uiBottomToolbar = uiBottomToolbar;
var $uiOverlay = 'env-overlay';
exports.$uiOverlay = $uiOverlay;
var uiOverlay = (0, _get_block.default)('env-overlay'); // Container

exports.uiOverlay = uiOverlay;
var $uiPanel = 'env-panel';
exports.$uiPanel = $uiPanel;
var uiPanel = (0, _get_block.default)('env-panel'); // Container

exports.uiPanel = uiPanel;
var $uiMenuDropdown = 'env-menu-dropdown';
exports.$uiMenuDropdown = $uiMenuDropdown;
var uiMenuDropdown = (0, _get_block.default)('env-menu-dropdown'); // Menu

exports.uiMenuDropdown = uiMenuDropdown;
var $uiMenuFolder = 'env-menu-folder';
exports.$uiMenuFolder = $uiMenuFolder;
var uiMenuFolder = (0, _get_block.default)('env-menu-folder'); // Menu

exports.uiMenuFolder = uiMenuFolder;
var $uiInfo = 'env-info';
exports.$uiInfo = $uiInfo;
var uiInfo = (0, _get_block.default)('env-info'); // Info

exports.uiInfo = uiInfo;
var $uiBadge = 'env-badge';
exports.$uiBadge = $uiBadge;
var uiBadge = (0, _get_block.default)('env-badge'); // Info

exports.uiBadge = uiBadge;
var $uiAlert = 'env-alert';
exports.$uiAlert = $uiAlert;
var uiAlert = (0, _get_block.default)('env-alert'); // Info

exports.uiAlert = uiAlert;
var $uiLoader = 'env-loader';
exports.$uiLoader = $uiLoader;
var uiLoader = (0, _get_block.default)('env-loader'); // Info

exports.uiLoader = uiLoader;
var $uiIconStack = 'env-icon-stack';
exports.$uiIconStack = $uiIconStack;
var uiIconStack = (0, _get_block.default)('env-icon-stack'); // Icon

exports.uiIconStack = uiIconStack;
var $uiIconSvg = 'env-icon-svg';
exports.$uiIconSvg = $uiIconSvg;
var uiIconSvg = (0, _get_block.default)('env-icon-svg'); // Icon

exports.uiIconSvg = uiIconSvg;
var $uiShowOnHover = 'env-show-on-hover';
exports.$uiShowOnHover = $uiShowOnHover;
var uiShowOnHover = (0, _get_block.default)('env-show-on-hover'); // Abstract

exports.uiShowOnHover = uiShowOnHover;
var $uiFocus = 'env-focus';
exports.$uiFocus = $uiFocus;
var uiFocus = (0, _get_block.default)('env-focus'); // Abstract

exports.uiFocus = uiFocus;
var $uiVisual = 'env-visual';
exports.$uiVisual = $uiVisual;
var uiVisual = (0, _get_block.default)('env-visual'); // Specific

exports.uiVisual = uiVisual;
var $uiS3Uploader = 'env-s3-uploader';
exports.$uiS3Uploader = $uiS3Uploader;
var uiS3Uploader = (0, _get_block.default)('env-s3-uploader'); // Third party

exports.uiS3Uploader = uiS3Uploader;
var $uiRange = 'env-range';
exports.$uiRange = $uiRange;
var uiRange = (0, _get_block.default)('env-range'); // Input

exports.uiRange = uiRange;
var $uiDivider = 'env-divider';
exports.$uiDivider = $uiDivider;
var uiDivider = (0, _get_block.default)('env-divider'); // Info

exports.uiDivider = uiDivider;
var $uiConnector = 'env-connector';
exports.$uiConnector = $uiConnector;
var uiConnector = (0, _get_block.default)('env-connector'); // Abstract

exports.uiConnector = uiConnector;
var $uiPlaceholder = 'env-placeholder';
exports.$uiPlaceholder = $uiPlaceholder;
var uiPlaceholder = (0, _get_block.default)('env-placeholder'); // Abstract
//
// JS block names

exports.uiPlaceholder = uiPlaceholder;